import { PaginationType } from '@api';
import { DEFAULT_PAGE, getParamName } from '../../../../../../common';

type GetPageOptionsType = {
  pagination?: PaginationType;
  search: Record<string, unknown>;
  tableId?: string;
};

export const getPage = ({
  pagination,
  search,
  tableId,

}: GetPageOptionsType): number => {
  return (
    pagination?.page ??
    (search?.[getParamName('page', tableId)] as number | undefined) ??
    DEFAULT_PAGE
  );
};
